import { createFileRoute } from "@tanstack/react-router"

import { ConversationsView } from "@/components/conversations/conversations-view"

export const Route = createFileRoute("/$dealership/conversations")({
  staticData: {
    breadcrumb: "Conversations",
  },
  validateSearch: (search: Record<string, unknown>) => ({
    category: typeof search.category === "string" ? search.category : undefined,
    status: typeof search.status === "string" ? search.status : undefined,
  }),
  component: ConversationsLayout,
})

function ConversationsLayout() {
  return (
    <div className="px-4 lg:px-6">
      <ConversationsView />
    </div>
  )
}
